import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import { useSelector, useDispatch } from 'react-redux';
import * as _ from 'lodash';
const classNames = require('classnames')
import axios from 'axios';

import CollapsibleComponent from "../../../components/Collapsible";
import RightContainerHeader from './header';
import Children from './child';
// import FollowerHeader from './followerHeader';
// import FollowerChildren from './followerChildren';
import AssociatedWorkkard from './associatedWorkkard';
import WorkkardFiles from './workkardFiles';
import WorkkardDetailForPopUpComponent from './workkardDetailForPopUpComponent';
// import CreateButton from "@CreateButton";
import Icon from '../../../icons';
import FieldRenderingEngine from "../../../components/FieldRenderingEngine";
import CloseWorkkardComponent from '../../../components/CloseWorkkard';
import ReopenWorkkardComponent from '../../../components/ReopenWorkkard';
import ContactInsuredComponent from '../../../components/ContactInsured';
import ShareProposalComponent from '../../../components/ShareProposal';
import { showDialogueBox, hideDialogueBox } from '../../../components/DialogueBox/actions';
import { IS_PARTIES_ENABLED, StringConstants, CharConstants, ActivityActions, WorkkardActions, MiddlePanelConstant, RedirectURI, RightPanelConstant, RenderEngineKey, DATE_FORMAT } from '../../../containers/WorkkardDetail/constants';
import moment from 'moment';

import { useModules } from '../../../utils/modules';
import { getActivityDetail, setPanelVisibility, updateMiddlePanelNotesData, updateWorkkardField, fetchWorkkardCarrier, updateUserCustomFieldData, resetUserCFData, updateUserPinnedFields } from "../../../containers/WorkkardDetail/actions/action";
import { fetchAssociatedWorkkardFilterRequest, saveMessageQueue } from '../slice';
import { WorkkardDetailSec1tLoader, OwnerLoader } from '../../../components/SkeletonLoader';
import ChangeOwnerBlock from './changeOwnerBlock';
import { showRightPopUpeBox, hideRightPopUpBox } from "../../../components/RightPopUpComponent/actions";
import { setPartyAssociation } from "../../Header/actions/action";
import AssociatedPartiesComponent from '../../Header/AssociatedParties';
import { showToast, hideToast } from '../../SpockViewPage/actions/action';
import ConfirmationTextBox from "../../../components/ConfirmationPrompt";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';



const CustomEngine = FieldRenderingEngine;
import DiaryCreation from "../../CreationForms/DiaryCreation";
import { getCustomerLastName, dispatchCustomEvent } from '../../WorkkardDetail/utils';
import { addClass, copyTextToClipboard, getMenuActions, httpCall, isDesktop, isMobile, mobileAndTabletcheck, removeClass, setObjectInStorage } from "../../../common/util";
import { ENDPOINTS, buildUrl } from "../../../config/apiEndpoints";


const RightPanelContainer = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isModuleEnabled, moduleLabel } = useModules();

    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const panelVisibility = useSelector(state => state.workkardDetail.panelVisibility);
    const isLoading = useSelector(state => state.workkardDetail.detailPage.isLoading);
    const rightPopUpComponent = useSelector(state => state.rightPopUpComponent);
    const draftIdQueue = useSelector(state => state.workkardDetail.contactInsured.draftIdQueue);
    const middlePanel = useSelector(state => state.workkardDetail.middlePanel);
    const sendVia = useSelector(state => state.workkardDetail.contactInsured.sendVia);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermission = userView?.permissions;
    

    const defaultThirdLayoutHeightRef = useRef(null);
    const thirdLayoutRef = useRef(null);
    const headingWkDetailRef = useRef(null);
    const wkMainInfoRef = useRef(null);
    const changeOwnerDivRef = useRef(null);
    const menuRef = useRef(null);
    const intervalRef = useRef(null);

    const [openFollower, setOpenFollower] = useState(false);
    const [canChangeActivityOwner, setCanChangeActivityOwner] = useState(false);
    const [canChangeActivityAssignee, setCanChangeActivityAssignee] = useState(false);
    const [canChangeWorkkardOwner, setCanChangeWorkkardOwner] = useState(false);
    const [CollapsibleDynamicHeight, setCollapsibleDynamicHeight] = useState(0);
    const [showMenuAction, setShowMenuAction] = useState(false);
    const [showWorkkardMainInfo, setShowWorkkardMainInfo] = useState(true);
    const [showAssociatedWorkkards, setShowAssociatedWorkkards] = useState(true);
    const [showWorkkardOwners, setShowWorkkardOwners] = useState(true);
    const [isWorkkardInfoCollapsed, setIsWorkkardInfoCollapsed] = useState(false);
    const [addAnimationClassOnThirdLayout, setAddAnimationClassOnThirdLayout] = useState(false);
    const [showAssociatedWorkkardPopUp, setShowAssociatedWorkkardPopUp] = useState(false);
    const [isChangeOwner, setIsChangeOwner] = useState(false);
    const [canEditWorkkard, setCanEditWorkkard] = useState(false);
    const [isMobileState, setIsMobileState] = useState(false);
    const [isCopySuccess, setIsCopySuccess] = useState(false);
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const [delay, setDelay] = useState(7000);
    const [userCustomFieldData, setUserCustomFieldData] = useState([]);
    const [usercfrefreshed, setUsercfrefreshed] = useState(false);
    const userCustomFieldDataRef = React.useRef([])

    useEffect(() => {
        userCustomFieldDataRef.current = userCustomFieldData
    }, [userCustomFieldData])


    useEffect(() => {
        if (mobileAndTabletcheck() && !isMobile()) {
            onCloseWorkkardInfo();
        }
        document.addEventListener('mousedown', onClickMenuOutside);
        window.addEventListener('resize', () => setTimeout(() => CalculateCollapsibleDynamicHeight(), 500));
        if (thirdLayoutRef.current && thirdLayoutRef.current.clientHeight) {
            CalculateCollapsibleDynamicHeight();
            defaultThirdLayoutHeightRef.current = Math.floor(thirdLayoutRef.current.clientHeight);
        }
        if (workkard && workkard.Id) {
            let wkMenuActions = getMenuActions(WorkkardActions, workkard.ActionMenu);
            setCanChangeWorkkardOwner(wkMenuActions.filter(item => item.value.includes(StringConstants.ChangeWorkkardSponsor)).length > 0);
        }
        if (activityDetail && activityDetail.activityId) {
            let menuActions = getMenuActions(ActivityActions, activityDetail.activityActions);
            setCanChangeActivityOwner(menuActions.filter(item => item.value.includes(StringConstants.ChangeActivityOwner)).length > 0);
            setCanChangeActivityAssignee(menuActions.filter(item => item.value.includes(StringConstants.ReassignActivity)).length > 0);
        }
        if (!panelVisibility.isRightPanelExpand) {
            document.body.classList.add('centerLayout');
        }
        if (panelVisibility.showWkInMobileView) {
            dispatch(fetchAssociatedWorkkardFilterRequest({ templateType: 'HCI', wkId: workkard.Id }));
        }
        return () => {
            document.body.classList.remove('centerLayout');
            document.removeEventListener('mousedown', onClickMenuOutside);
            window.removeEventListener('resize', CalculateCollapsibleDynamicHeight);
            dispatch(showRightPopUpeBox({ flag: false }));
        };
    }, []);

    useEffect(() => {
        if (workkard.ActionMenu && workkard.ActionMenu.length > 0) {
            let wkMenuActions = getMenuActions(WorkkardActions, workkard.ActionMenu);
            setCanChangeWorkkardOwner(wkMenuActions.filter(item => item.value.includes(StringConstants.ChangeWorkkardSponsor)).length > 0);
            setCanEditWorkkard(isModuleEnabled("workkards.edit_workkard.inline_edit") && wkMenuActions.filter(item => item.value.includes(StringConstants.EditWorkkard)).length > 0);
        }
    }, [workkard.ActionMenu]);

    useEffect(() => {        
        if (activityDetail) {
            let menuActions = getMenuActions(ActivityActions, activityDetail.activityActions);
            
            setCanChangeActivityOwner(menuActions.filter(item => item.value.includes(StringConstants.ChangeActivityOwner)).length > 0);
            setCanChangeActivityAssignee(menuActions.filter(item => item.value.includes(StringConstants.ReassignActivity)).length > 0);
        }
    }, [activityDetail && activityDetail.activityId, activityDetail && activityDetail.activityActions]);

    useEffect(() => {
        if (usercfrefreshed && workkard.CustomFields) {
            setUsercfrefreshed(false);
        }
    }, [workkard.CustomFields]);

    useEffect(() => {
        if (props.enableWorkkardDetailPopUp) {
            showWorkkardDetailPopUp();
        }
    }, [props.enableWorkkardDetailPopUp]);

    useEffect(() => {
        if (props.enableAssociatedWorkkardDetailPopUp) {
            setShowAssociatedWorkkardPopUp(true);
        }
    }, [props.enableAssociatedWorkkardDetailPopUp]);

    useEffect(() => {
        if (thirdLayoutRef.current && thirdLayoutRef.current.clientHeight) {
            const thirdLayoutHeight = Math.floor(thirdLayoutRef.current.clientHeight);
            if (thirdLayoutHeight !== defaultThirdLayoutHeightRef.current) {
                defaultThirdLayoutHeightRef.current = thirdLayoutHeight;
                CalculateCollapsibleDynamicHeight();
            }
        }
    });

    useEffect(() => {
        setIntervalFn();
    }, [draftIdQueue.length]);

    useEffect(() => {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(polling, delay);
    }, [delay]);
  
    useEffect(() => {
        if (workkard.Id !== undefined && isModuleEnabled("workkards.associated_workkard.filters")) {
            dispatch(fetchAssociatedWorkkardFilterRequest({ templateType: 'HCI', wkId: workkard.Id }));
        }
    }, [workkard.Id]);

    const resetComponentDisplayStates = (objState) => {
        if ((objState.hasOwnProperty('showWorkkardMainInfo') && objState.showWorkkardMainInfo) || (objState.hasOwnProperty('showWorkkardOwners') && objState.showWorkkardOwners)
            || (objState.hasOwnProperty('showAssociatedWorkkards') && objState.showAssociatedWorkkards)
        ) {
            document.body.classList.remove('centerLayout');
        } else {
            document.body.classList.add('centerLayout');
        }
        const merged = Object.assign({}, { showWorkkardMainInfo: false, showAssociatedWorkkards: false, showWorkkardOwners: false, isWorkkardInfoCollapsed: false }, objState);
        setShowWorkkardMainInfo(merged.showWorkkardMainInfo);
        setShowAssociatedWorkkards(merged.showAssociatedWorkkards);
        setShowWorkkardOwners(merged.showWorkkardOwners);
        setIsWorkkardInfoCollapsed(merged.isWorkkardInfoCollapsed);
    };

    const openCollaps = (e) => { setOpenFollower(true); };

    const onClickMenuActionButton = () => { setShowMenuAction(prev => !prev); };

    const onClickMenuOutside = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setShowMenuAction(false);
        }
    };

    const getWorkkardMenuList = () => {
        if (workkard && workkard.ActionMenu) {
            const discardItemList = [StringConstants.ChangeWorkkardSponsor, StringConstants.CreateActivity];
            let menuActions = getMenuActions(WorkkardActions, workkard.ActionMenu);
            return (
                menuActions.map((item, key) => {
                    if (!discardItemList.includes(item.value)) {
                        if (sessionContext && userView && (item.value == StringConstants.CloseWorkkard || item.value == StringConstants.ReopenWorkkard) && workkard.OrganizationId !== userView.orgId) {
                            return null;
                        } else if ((item.value == StringConstants.CloseWorkkard || item.value == StringConstants.ReopenWorkkard) && !isModuleEnabled("workkards.status_open_close_reopen")) {
                            return null;
                        } else if (item.value == StringConstants.EditWorkkard && !isModuleEnabled("workkards.edit_workkard.edit_option")) {
                            return null;
                        } else {
                            return (
                                <span onClick={(e) => { return onClickWorkkardAction(e); }} key={key}><a href={setRedirectURI(item.value)}><Icon name={item.value.replace(/ /g, "").toLowerCase()} className="icon" />  {item.value}</a></span>
                            );
                        }
                    } else return null;
                })
            );
        } else {
            return null;
        }
    };
 
    const setRedirectURI = (action) => {
        switch (action) {
            case RedirectURI.EditWorkkard: return "javascript:void(0);";
            default: return "javascript:void(0);";
        }
    };

    const onClickWorkkardAction = (e) => {
        const isIE = false || !!document.documentMode;
        switch (e.target.innerText.trim()) {
            case StringConstants.EditWorkkard: {
                e.preventDefault();
                const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
                return navigate(`/workkards/edit/${workkard.Id}`, { state: { returnUrl } });
            }
            case StringConstants.AddNote: {
                dispatch(hideToast());
                return dispatch(setPanelVisibility({ templateType: CharConstants.Workkard, isLeftVisible: false, isRightVisible: false, isNoteVisible: true }));
            }
            case StringConstants.CloseWorkkard: {
                // claimcolony gets the full close flow (tabs for open
                // activities/diaries/unread notifications + a note) via
                // CloseWorkkardComponent. cche disables all three of those
                // sub-tabs already (workkards.close_workkard.open_*), which
                // would leave that component showing an almost-empty modal,
                // so cche instead gets a plain confirm/cancel prompt that
                // closes the workkard directly with no note-taking step.
                if (isModuleEnabled("workkards.close_workkard.detailed_flow")) {
                    return dispatch(showDialogueBox({
                        flag: true,
                        component: <CloseWorkkardComponent workkardId={workkard.Id} actId={activityDetail.activityId ? activityDetail.activityId : 0} />,
                        overlayClassName: "modal",
                        contentClassName: `${mobileAndTabletcheck() ? "modalContent animated faster fadeInUpx2" : "modalContent animated faster fadeInUpx2 fullView large modalAlignFromTop"}`,
                        shouldCloseOnOverlayClick: true
                    }));
                }
                return dispatch(showDialogueBox({
                    flag: true,
                    component: <ConfirmationTextBox
                        class={"modalBody"}
                        message={"With the closing of Workkard, all the open Activities will be marked as closed. Do you wish to continue?"}
                        onConfirmClick={closeWorkkardConfirmed}
                        onCancelClick={closeConfirmationBox}
                        confirmationText={"Continue"}
                        cancelText={"Cancel"}
                        footerClass={"modalFooter"}
                    />,
                    overlayClassName: "modal",
                    contentClassName: "modalContent animated faster fadeInUpx2 small",
                    shouldCloseOnOverlayClick: true
                }));
            }

            case StringConstants.ReopenWorkkard: {
                let contentClassName = "modalContent animated faster fadeInUpx2 large reopenActivityModal";
                let component = <ReopenWorkkardComponent />;
                if (!userPermission?.can_reopen_activity && !userPermission?.can_create_activity) {
                    component = <ConfirmationTextBox
                        header={"Cannot Reopen Workkard!"}
                        class={"modalBody"}
                        message={RightPanelConstant.CanReopenWorkkardPermissionDenied}
                        onConfirmClick={closeConfirmationBox}
                        confirmationText={"Close"}
                        footerClass={"modalFooter"}
                    />;
                    contentClassName = "modalContent animated faster fadeInUpx2 small";
                }
                return dispatch(showDialogueBox({ flag: true, component, overlayClassName: "modal", contentClassName, shouldCloseOnOverlayClick: true }));
            }
            case StringConstants.ContactInsured: {
                return dispatch(showDialogueBox({
                    flag: true,
                    component: <ContactInsuredComponent Id={workkard.Id} setInterval={setIntervalFn} />,
                    overlayClassName: "modal",
                    contentClassName: "modalContent animated faster fadeInUpx2 large",
                    shouldCloseOnOverlayClick: false
                }));
            }
            case StringConstants.ShareProposal: {
                return dispatch(showDialogueBox({
                    flag: true,
                    component: <ShareProposalComponent workkardId={workkard.Id} workkardNumber={workkard.WorkkardNumber} />,
                    overlayClassName: "modal",
                    contentClassName: "modalContent animated faster fadeInUpx2 large",
                    shouldCloseOnOverlayClick: false
                }));
            }
            case StringConstants.RequestLetter: {
                setObjectInStorage("requestLetterClicked", true);
                setShowMenuAction(false);
                dispatch(setPanelVisibility({ isLeftVisible: false, isMiddleVisible: false, isVisibleExternalApp: true, toggleView: RightPanelConstant.LettersView.toLowerCase() }));
                return dispatchCustomEvent(isIE, 'requestLetterClicked');
            }
            case StringConstants.RequestReview: {
                setObjectInStorage("requestReviewClicked", true);
                setShowMenuAction(false);
                dispatch(setPanelVisibility({ isLeftVisible: false, isMiddleVisible: false, isVisibleExternalApp: true, toggleView: RightPanelConstant.ReviewsView.toLowerCase() }));
                return dispatchCustomEvent(isIE, 'requestReviewClicked');
            }
            default:
                return "";
        }
    };

    const closeConfirmationBox = () => { dispatch(hideDialogueBox()); };

    const closeWorkkardConfirmed = () => {
        httpCall({
            method: ENDPOINTS.WORKKARD.CLOSE.method,
            headers: { 'Content-Type': 'application/json' },
            url: buildUrl(ENDPOINTS.WORKKARD.CLOSE.url, { id: workkard.Id }),
        }).then((response) => {
            dispatch(hideDialogueBox());
            if (response?.status == 'success') {
                window.location.reload();
            } else {
                dispatch(showToast({
                    message: "Something went wrong while closing the Workkard. Please try again.",
                    type: "error",
                    autoClose: true,
                    delayTime: 4000,
                }));
            }
        });
    };

    const setIntervalFn = () => {
        intervalRef.current = setInterval(polling, delay);
    };

    const polling = () => {
        const workkardId = workkard.Id;
        const ActivityData = activityDetail;
        const activityDataId = ActivityData.activityId;
        const toggleView = panelVisibility.toggleView;

        if (draftIdQueue.length) {
            draftIdQueue.map((item) => {
                axios
                    .get("/getmsgobj", { params: { draftNoteId: item } })
                    .then(function (response) {
                        const { Data } = response.data;
                        if (Data != null && Data.Status != "") {
                            dispatch(saveMessageQueue({ Id: item, type: "pop" }));
                            const toastPayload = {
                                message: Data.toastText,
                                // type: Data.iconType,
                                iconType: Data.iconType,
                                delayTime: 5000,
                                entityType: Data.noteType,
                                cId: Data.noteType == StringConstants.activity ? workkardId : Data.typeId,
                                actId: Data.noteType == StringConstants.activity ? Data.typeId : 0,
                                showActions: true,
                                autoClose: true,
                            };
                            if (middlePanel.activeTab == 0) {
                                if ((middlePanel.notes.type == StringConstants.activity && Data.typeId === activityDataId) || (middlePanel.notes.type == StringConstants.workkard && Data.typeId === workkardId)) {
                                    const param = {
                                        type: Data.noteType,
                                        actId: Data.noteType == StringConstants.activity ? Data.typeId : 0,
                                        cId: Data.noteType == StringConstants.activity ? 0 : Data.typeId,
                                        skip: 0,
                                        take: middlePanel.notes.skip + middlePanel.notes.take || 10,
                                        sortBy: (middlePanel.notes.type == StringConstants.activity) ? "0" : "1",
                                        reviewFilter: "0"
                                    };
                                    dispatch(updateMiddlePanelNotesData(param));
                                }
                                if (Data.noteType == StringConstants.activity && Data.typeId != activityDataId) {
                                    dispatch(showToast(toastPayload));
                                }
                                if (middlePanel.notes.type != Data.noteType || toggleView != RightPanelConstant.NormalView) {
                                    dispatch(showToast(toastPayload));
                                }
                            } else {
                                dispatch(showToast(toastPayload));
                            }
                        } else {
                            // clearInterval(intervalRef.current);
                        }
                    });
            });
        } else {
            clearInterval(intervalRef.current);
        }
    };

    const createWorkkardRedirectLink = () => {
        const QuerySearchValues = props.location;
        if (QuerySearchValues) {
            const pathname = props.location.pathname.split("/")[1];
            return "/crtwrk?ret=" + pathname + props.location.search;
        }
        return null;
    };

    const renderCollapsibleChildren = (collapsibleProps, Carrier, isPinnedCustomfields) => {
        return (
            <>
                <ul className="rowFlex wrapFlex">
                    {renderCustomFields(collapsibleProps, true)}
                </ul>
                <div className="wkDescription">
                    <label className="mb__8 mt">Description</label>
                    <p dangerouslySetInnerHTML={{ __html: workkard.WorkkardSummaryFull != "" ? workkard.WorkkardSummaryFull : "-" }}></p>
                </div>
            </>
        );
    };

    const updateWorkkardFieldInfo = (data) => {
        let fieldData = data;
        if (data.hasOwnProperty("hdnshowcarriername")) {
            const carrier = workkard.workkardCarriers.filter(item => item.Name == data.hdnshowcarriername)[0];
            fieldData = { ...data, hdnshowcarriername: carrier?.Id };
        }
        dispatch(updateWorkkardField({ ...fieldData, callback: () => { console.log("Workkard Update SuccessFully"); } }));
    };

    const updateUserCustomData = (data) => {
        let userCustomdata = [];
        data.map(item => {
            if (item.length > 1) {
                item.forEach(e => { userCustomdata.push(e.Name); });
            } else {
                userCustomdata.push(item[0].Name);
            }
        });
        setUserCustomFieldData(userCustomdata);
    };

    const renderCustomFields = (cfProps, showCreatedDate = false, isShowDetailOnPopUp = false, canRearrange = false) => {
        const latestWorkkard = (cfProps && cfProps.workkardDetail) || workkard;
        if (latestWorkkard && latestWorkkard.CustomFields) {
            const customFieldsKey = `${latestWorkkard.Id}-${latestWorkkard.customFieldsOrderVersion || 0}`;
            return (
                <>
                    <CustomEngine
                        key={customFieldsKey}
                        data={latestWorkkard.CustomFields}
                        workkardDetail={latestWorkkard}  
                        dragndrop={canRearrange} 
                        userTimezone={sessionContext.TimeZoneTz} 
                        tzData={sessionContext.tzData} 
                        isShowDetailOnPopUp={isShowDetailOnPopUp} 
                        canEditWorkkard={canEditWorkkard} 
                        updateWorkkardFieldInfo={(data) => updateWorkkardFieldInfo(data)} renderLocation={'detail'} 
                        renderType={'workkard'} 
                        updateUserCustomData={(data) => updateUserCustomData(data)} 
                        {...cfProps} 
                    />
                    {
                        (showCreatedDate && (workkard.CreatedDateString != null || workkard.CreatedDateString != "" || workkard.CreatedDate)) &&
                        <li>
                            <label>Created Date</label>
                            {moment.unix(workkard.CreatedDate).utc().format(DATE_FORMAT)}
                        </li>
                    }
                </>
            );
        } else
            return "";
    };

    const onCloseWorkkardDetail = () => { dispatch(setPanelVisibility({ isRightVisible: false })); };

    /** on close  workkard info update  state */
    const onCloseWorkkardInfo = () => {
        document.body.classList.add('centerLayout');
        setShowWorkkardMainInfo(false);
        setShowAssociatedWorkkards(false);
        setShowWorkkardOwners(false);
        setAddAnimationClassOnThirdLayout(false);
        dispatch(setPanelVisibility({ templateType: CharConstants.Workkard, isRightPanelExpand: false }));
    };

    const expandMiddlePanel = () => {
        document.body.classList.add('centerLayout');
        setShowWorkkardMainInfo(false);
        setShowAssociatedWorkkards(false);
        setShowWorkkardOwners(false);
        setAddAnimationClassOnThirdLayout(false);
        dispatch(setPanelVisibility({ templateType: CharConstants.Workkard, isRightPanelExpand: false, isLeftVisible: false, isFullViewActive: true }));
    };

    const closeDialogBox = () => {
        if (isLoading) return;
        setIsPopUpOpen(false);
        dispatch(showDialogueBox({ flag: false, dialogueBoxComponent: null }));
        props.closeWorkkardDetailPopUp();
    };

    const saveUserCFSettings = () => {
        if (userCustomFieldDataRef.current.length > 0) {
            const payload = {
                pinned_field: userCustomFieldDataRef.current.join(),
                template_id: workkard.TemplateId,
            };
            setUserCustomFieldData([]);
            setUsercfrefreshed(true);
            dispatch(updateUserPinnedFields(payload))
        }
    };

    const resetUserCFSettings = () => {
        dispatch(resetUserCFData({ templateId: workkard.TemplateId, wkId: workkard.Id }));
    };

    const togglecfloader = () => { setUsercfrefreshed(false); };

    const workkardDetailPopUpComponent = () => {
        return (<WorkkardDetailForPopUpComponent togglecfloader={togglecfloader} saveUserCFSettings={saveUserCFSettings} resetUserCFSettings={resetUserCFSettings} closeDialogBox={closeDialogBox} canEditWorkkard={canEditWorkkard} workkardDetailInfo={workkardDetailInfo} renderCustomFields={renderCustomFields} getExcludeFields={getExcludeFields} updateWorkkardFieldInfo={(data) => updateWorkkardFieldInfo(data)} />);
    };

    const showWorkkardDetailPopUp = () => {
        dispatch(fetchWorkkardCarrier());
        dispatch(showDialogueBox({
            flag: true,
            component: workkardDetailPopUpComponent(),
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: false
        }));
    };

    const onClickCopy = (text) => {
        copyTextToClipboard(text, () => { setIsCopySuccess(true); });
    };

    const workkardDetailInfo = (wk, isExpanded, isShowDetailOnPopUp = false) => {
        let workkardStatusClass = wk && wk.WorkkardStatus && wk.WorkkardStatusForDisplay.toLowerCase();
        let WorkkardReopenReason = wk && wk.WorkkardStatusForDisplay === StringConstants.Reopened && wk.WorkkardReopenReason;
        let isLitTPAClaimExistForGTPAWkd = wk && wk.litClaimStatusForWorkkard != "" ? true : false;
        let litClaimStatus = isLitTPAClaimExistForGTPAWkd == true ? wk.litClaimStatusForWorkkard : "";
        let litClaimText = wk && wk.litClaimStatusForWorkkard && wk.litClaimStatusForWorkkard != "" ? `Lawsuit (${litClaimStatus})` : "";

        const workkardNumber = wk.WorkkardNumber;

        const customerName = ReactDOMServer.renderToString(<CustomEngine data={wk.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.CustomerName]} />).replace(/<!--[^>]*-->/g, "");
        let tooltipText, copyText = customerName.trim().length ? `${workkardNumber} - ${customerName}` : workkardNumber;
        const el = document.querySelector(".ReactModalPortal .copyText");
        copyText = $("<div/>").html(copyText).text(); //it is a hotfix, need to handle decoding EC-59245
        if (isCopySuccess) {
            tooltipText = "Copied!";
            el && addClass(el, "copySuccess");
        } else {
            tooltipText = customerName.trim().length ? moduleLabel("workkards.header.copy_number_and_name", "Copy Workkard Number and Insured Name") : "Copy Workkard Number";
        }
        el && el.setAttribute("data-quicktooltip", tooltipText);
        if (wk) {
            return (
                <div className="rowFlex">
                    <div className="cardDefaultInfo colFlex flexGrow" >
                        <div>
                            {wk && wk.WorkkardTitle}
                        </div>
                        <div className="alignMiddle">
                            <div className="wkDetailNumber flexWrap alignMiddle">
                                <div className="wkColumn flexWrap alignMiddle">
                                    <span className="wkNumber status mr">
                                        {workkardNumber}
                                    </span>
                                    <span onMouseLeave={() => {
                                        const el = document.querySelector(".ReactModalPortal .copyText");
                                        el && removeClass(el, "copySuccess");
                                        setIsCopySuccess(false);
                                    }} className={`copyText quickTooltip-bottom selfStart alignMiddle animated fast fadeInLeftSmall mr ${isCopySuccess ? 'copySuccess' : ''}`} data-quicktooltip={tooltipText} >
                                        <span className="alignMiddle iconRipple" onClick={() => onClickCopy(copyText)} ><Icon name="copy" className="icon" /></span>
                                    </span>
                                    {" "}
                                    {" "}
                                    <span className={"status mr " + workkardStatusClass + " workkardStatus"}>
                                        {workkardStatusClass}{WorkkardReopenReason ? ` (${WorkkardReopenReason}${wk.WorkkardReopenSubReason ? ` - ${wk.WorkkardReopenSubReason}` : ''})` : ''}
                                    </span>
                                    {litClaimText != "" && <span className={"status statusFilled law  lawFilled workkardStatus"}>
                                        <span className="label mr">/</span>
                                        <strong>{litClaimText}</strong>
                                    </span>}
                                </div>
                            </div>
                        </div>
                        <ul className="rowFlex wrapFlex">
                            {renderCustomFields({ includeFields: [RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName] }, false, isShowDetailOnPopUp)}
                        </ul>
                    </div>
                    {
                        !isExpanded && <div className="rowFlex flexNone">
                            <span className="alignMiddle iconRipple mr" onClick={showWorkkardDetailPopUp}><Icon name="expand" className="icon" /></span>
                            {!sessionContext.IsAuditUser &&
                                <React.Fragment>
                                    <div className={showMenuAction ? "dropDown active h__24" : "dropDown h__24"} ref={menuRef}>
                                        <span className="icon" onClick={onClickMenuActionButton}><Icon name="more" className="icon more" /></span>
                                        <div className={showMenuAction ? "dropDownMenu openRight onClick" : "dropDownMenu openRight"}>
                                            {getWorkkardMenuList()}
                                            {wk.IsCurrentOrgInvolved && isModuleEnabled("diaries") && <a className="pointer" onClick={onAddDiaryClick}>{RightPanelConstant.CreateDiarytext}</a>}
                                            {IS_PARTIES_ENABLED == "true" && isModuleEnabled("parties") && <a href="javascript:void(0);" id="associatePartyWorkkard" onClick={onAddPartyClick}>{MiddlePanelConstant.AddPartyText}</a>}
                                            {isModuleEnabled("workkards.print_workkard_details") && <a onClick={() => setShowMenuAction(false)} href={"/printworkkarddetail?cId=" + workkard.Id} target="_blank" rel="noopener noreferrer">{RightPanelConstant.PrintWorkkardDetailtext}</a>}
                                        </div>
                                    </div>
                                </React.Fragment>}
                        </div>
                    }
                </div>
            );
        }
    };


    const CalculateCollapsibleDynamicHeight = () => {
        //  let headerRight = document.getElementsByClassName('headerRight alignMiddle pd__n__r').length ? document.getElementsByClassName('headerRight alignMiddle pd__n__r')[0].getBoundingClientRect().height : 0;
        let rowFlex = headingWkDetailRef.current ? headingWkDetailRef.current.clientHeight : 0;
        let wkMainInfoH = wkMainInfoRef.current ? wkMainInfoRef.current.clientHeight : 0;
        let thirdLayoutH = thirdLayoutRef.current ? thirdLayoutRef.current.clientHeight : 0;
        let changeOwnerDivHeight = changeOwnerDivRef.current ? changeOwnerDivRef.current.clientHeight : 0;

        let calCulatedHeight = thirdLayoutH - (rowFlex + wkMainInfoH + changeOwnerDivHeight);

        let isMobileCheck = mobileAndTabletcheck() || window.innerWidth <= 1024;

        // this.prevWkMainInfoHeight = wkMainInfoH;
        // this.prevChangeOwnerDivHeight = changeOwnerDivHeight;

        setCollapsibleDynamicHeight(calCulatedHeight > 200 ? calCulatedHeight : 200);
        setIsMobileState(isMobileCheck);
    };

    const closeDiaryCreationForm = () => {
        dispatch(showDialogueBox({ flag: false, dialogueBoxComponent: null }));
    };

    const onAddDiaryClick = () => {
        // href={createTodoUrl(StringConstants.workkard, workkard.Id, activityId, workkard.Id, workkard.CustomFields, workkard.WorkkardNumber)}
        dispatch(showDialogueBox({
            flag: true,
            component: <DiaryCreation
                actId={activityDetail.activityId || 0}
                wkId={workkard.Id}
                wkNumber={workkard.WorkkardNumber}
                type={StringConstants.workkard}
                customerLastName={getCustomerLastName(workkard.CustomFields)}
                onClose={closeDiaryCreationForm}
                referrer={"getclmdetail"}
            />,
            overlayClassName: "modal",
            contentClassName: `${mobileAndTabletcheck() ? "modalContent animated faster fadeInUpx2" : "modalContent animated faster fadeInUpx2 fullView medium modalAlignFromTop"}`,
            shouldCloseOnOverlayClick: false
        }));
    };

    const renderPhone = (wk, isExpanded, isShowDetailOnPopUp = false) => {
        let ccphone = ReactDOMServer.renderToString(<CustomEngine data={wk.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.CarrierContactPhone]} />);
        const el = document.querySelector(".ReactModalPortal .ccphone");
        if (isCopySuccess && el) {
            addClass(el, "copySuccess");
            el.dataset.quicktooltip = "Copied!";
        }

        if (ccphone) {
            if (isShowDetailOnPopUp) {
                return renderCustomFields({ includeFields: [RenderEngineKey.CarrierContactPhone], showLabel: true }, false, isShowDetailOnPopUp);
            } else {
                return (
                    isExpanded ? (
                        <li>
                            <label>Carrier Contact Phone </label>
                            <span className="wkDetailNumber">{ccphone}
                                {ccphone != "-" ? <span onMouseLeave={() => {
                                    const el = document.querySelector(".ReactModalPortal .ccphone");
                                    if (el) {
                                        removeClass(el, "copySuccess");
                                        el.dataset.quicktooltip = "Copy number";
                                    }
                                    setIsCopySuccess(false);
                                }} className={`copyText ccphone wth-80 quickTooltip-bottom selfStart alignMiddle animated fast fadeInLeftSmall ${isCopySuccess ? 'copySuccess' : ''}`} data-quicktooltip={isCopySuccess ? "Copied!" : "Copy number"} >
                                    <span className="ml" onClick={() => onClickCopy(ccphone)}><Icon name="copy" className="icon" /></span>
                                </span> : null}
                            </span>
                        </li>
                    ) : (
                        ccphone != '-' ?
                            <span onMouseLeave={() => { setIsCopySuccess(false); }} className={`copyText wth-80 quickTooltip-top ${isCopySuccess ? 'copySuccess' : ''}`} data-quicktooltip={isCopySuccess ? "Copied!" : ccphone}>
                                <span className="iconHover" onClick={() => onClickCopy(ccphone)}><Icon name="mobile" className="icon" /></span>
                            </span> : null
                    )
                );
            }
        }
    };

    const workkardMainInfo = (wk) => {
        let activityId = activityDetail.activityId || 0;
        let ccname = ReactDOMServer.renderToString(<CustomEngine data={wk.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.CarrierContactName]} />);
        let ccemail = ReactDOMServer.renderToString(<CustomEngine data={wk.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.CarrierContactEmail]} />);
        let cclaimnumber = ReactDOMServer.renderToString(<CustomEngine data={wk.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.CarrierClaimNumber]} />);
        let isClaimSourceExist = wk.CustomFields && wk.CustomFields.some(obj => obj.FieldKey == "claimsource_string");
        let carriername = wk.TemplateShortName == "COMMERCIAL" ? (wk.CarrierNameAbbr || wk.CarrierName) : '';
        return (
            (workkard && Object.keys(workkard).length > 0 && showWorkkardMainInfo) ?
                <div ref={wkMainInfoRef}>
                    <div className="wkMainInfo mb">
                        {
                            !(wk) ?
                                <WorkkardDetailSec1tLoader />
                                :
                                (
                                    <>
                                        {workkardDetailInfo(wk, false)}

                                        <div className="colFlex propertyLocation mb__12" data-test="clmdetail propertyLocation">
                                            <ul className="rowFlex wrapFlex">
                                                {renderCustomFields({ includeFields: [RenderEngineKey.PropertyLocation] })}
                                            </ul>
                                        </div>

                                        {!wk.IsPinnedCustomfields &&
                                            (
                                                (wk.CarrierName && (wk.CarrierName.trim() != null || wk.CarrierName.trim() != ""))
                                                || wk.TemplateShortName == "QUOTESUBMISSION"
                                            ) ?
                                            <>
                                                {renderCarrierAndCarrirClaimNumber(cclaimnumber, wk)}
                                                {ccname ?
                                                    <div className="rowFlex alignMiddle mt">
                                                        <div className="colFlex wrapFlex flexGrow">
                                                            <label>Carrier Contact Name</label>
                                                            <span>{ccname}</span>
                                                        </div>
                                                        <div className="carrierContact">
                                                            {renderPhone(wk, false)}
                                                            {ccemail.trim() && ccemail != '-' ?
                                                                <span className="ml email rightAlign" onClick={() => { window.location.href = `mailto:${ccemail}`; }} data-quicktooltip={ccemail}>
                                                                    <span className="iconHover"><Icon name="email" className="icon" /></span>
                                                                </span> : null
                                                            }
                                                        </div>
                                                    </div> : null
                                                }
                                            </>
                                            :
                                            null
                                        }
                                    </>
                                )
                        }
                        <CollapsibleComponent
                            updateCollapsibleState={(data) => { setIsWorkkardInfoCollapsed(data); }}
                            header={
                                <RightContainerHeader isLoading={usercfrefreshed}>
                                    <ul className="rowFlex wrapFlex">
                                        {renderCustomFields({ includeFields: getIncludeFields(isClaimSourceExist, wk.IsPinnedCustomfields, wk.TemplateShortName), showLabel: true })}
                                    </ul>
                                </RightContainerHeader>
                            }
                            openButton={OpenButton}
                            closeButton={CloseButton}>
                            <Children renderFields={(data) => renderCollapsibleChildren(data, wk.TemplateShortName == "COMMERCIAL" ? (carriername) : '', wk.IsPinnedCustomfields)} customHeight={CollapsibleDynamicHeight} workkard={wk} IsForClaimWorkkard={wk.IsClaimWorkkard} IsPinnedCustomfields={wk.IsPinnedCustomfields} />
                        </CollapsibleComponent>
                    </div>
                </div>
                : null
        );
    };

    const renderCarrierAndCarrirClaimNumber = (cclaimnumber, workkardData) => {
        if (cclaimnumber) {
            return (<div className="wkDetailInfo">
                <ul className="rowFlex wrapFlex">
                    <li><label>Carrier</label><span>{workkardData.CarrierNameAbbr || workkardData.CarrierName}</span></li>
                    <li><label>Carrier Claim Number</label><span>{cclaimnumber}</span></li>
                </ul>
            </div>);
        } else if (workkardData.IsClaimWorkkard) {
            let tracKFieldValue = workkardData.CustomFields && workkardData.CustomFields.some(obj => obj.FieldGroup == "Track") &&
                ReactDOMServer.renderToString(<CustomEngine data={workkardData.CustomFields} renderLocation={'detail'} renderType={'string'} includeFields={[RenderEngineKey.Track]} />);
            return (<div className="wkDetailInfo">
                <ul className="rowFlex wrapFlex">
                    <li><label>Carrier</label><span>{workkardData.CarrierNameAbbr || workkardData.CarrierName}</span></li>
                    {tracKFieldValue && <li><label>Track</label><span>{tracKFieldValue}</span></li>}
                </ul>
            </div>);
        } else if (workkardData.TemplateShortName == "COMMERCIAL" || workkardData.TemplateShortName == "QUOTESUBMISSION") {
            return (<div className="wkDetailInfo">
                <ul className="rowFlex wrapFlex">
                    {renderCustomFields({ includeFields: [RenderEngineKey.BuildingType, RenderEngineKey.BuildingDescription], showLabel: true, workkardDetail: workkardData })}
                </ul>
            </div>);
        } else {
            return (<div><label>Carrier</label><span>{workkardData.CarrierNameAbbr || workkardData.CarrierName}</span></div>);
        }
    };

    const getExcludeFields = () => [RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName, RenderEngineKey.WorkkardNumber, RenderEngineKey.WorkkardTitle];

    const getIncludeFields = (isClaimSourceExist, isPinnedCustomfields, templateShortName) => {
        let collapsefields = [];
        if (isPinnedCustomfields) {
            var cffiltereddata = workkard.CustomFields.filter(x => x.FieldGroup != RenderEngineKey.PropertyLocation && x.FieldGroup != RenderEngineKey.CustomerName && x.FieldGroup != RenderEngineKey.WorkkardTitle);
            [RenderEngineKey.BuildingType, RenderEngineKey.BuildingDescription].forEach((group) => {
                if (cffiltereddata.some(x => x.FieldGroup === group) && !collapsefields.includes(group)) {
                    collapsefields.push(group);
                }
            });
            for (let index = 0; collapsefields.length < 4 && index < cffiltereddata.length; index++) {
                if (!collapsefields.includes(cffiltereddata[index].FieldGroup)) {
                    collapsefields.push(cffiltereddata[index].FieldGroup);
                }
            }
        } else {
            if (isClaimSourceExist) {
                collapsefields = [RenderEngineKey.ClaimSource, RenderEngineKey.LossType];
            } else {
                collapsefields = templateShortName == "COMMERCIAL" ? ["Carrier", RenderEngineKey.LossType] : [RenderEngineKey.PolicyType, RenderEngineKey.LossType];
            }
        }
        return collapsefields;
    };

    const closeAssociatedWorkkardDetailPopUp = () => {
        setShowAssociatedWorkkardPopUp(false);
        props.closeAssociatedWorkkardDetailPopUp();
    };


    const associatedWorkkard = (wk) => {
        return (showAssociatedWorkkards ? <AssociatedWorkkard wkId={wk.Id} className={`${(!showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? 'fadeInUp' : ""}`} showAssociatedWorkkardDetail={showAssociatedWorkkardPopUp} closeAssociatedWorkkardDetailPopUp={closeAssociatedWorkkardDetailPopUp} /> : null);
    };


    const changeOwnerComponent = (wk) => {
        const thirdLayoutData = document.getElementsByClassName("thirdLayout").length ? document.getElementsByClassName("thirdLayout")[0].getBoundingClientRect() : 0;
        return (
            showWorkkardOwners ?
                <div className={`changeOwner mt__1 animated faster ${(!showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? 'fadeInUp' : ""}`}
                // style={{
                //     display: isMobileState && !props.showChangeOwnerBlock ? "none" : ""
                // }}
                >
                    {/* {isMobileState &&  */}
                    <header className="rowFlex rowSpaceBetween alignMiddle pdl__1 pdr__1">
                        <h2>Change Owner/Assignee</h2>
                        <span className="iconRipple" onClick={props.toggleChangeOwnerBlock}><Icon name="close" className="icon" /></span>
                    </header>
                    {/* } */}
                    {
                        !(workkard) ?
                            <OwnerLoader count={3} />
                            :
                            <>
                                <ChangeOwnerBlock
                                    canChangeActivityAssignee={canChangeActivityAssignee}
                                    canChangeActivityOwner={canChangeActivityOwner}
                                    canChangeWorkkardOwner={canChangeWorkkardOwner}
                                    layoutData={thirdLayoutData}
                                    isMobile={isMobileState}
                                />
                            </>
                    }
                </div>
                : null
        );
    };

    const onAddPartyClick = () => {
        dispatch(setPartyAssociation("workkard"));
        dispatch(showRightPopUpeBox({
            flag: true,
            component: <AssociatedPartiesComponent onClose={closeRightPopUp} associateWith="workkard" />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        }));
        setShowMenuAction(false);
    };

    const closeRightPopUp = () => { dispatch(hideRightPopUpBox()); };

    const switchViewClick = (view) => {
        const panelVisibilityPayload = {
            templateType: CharConstants.Workkard,
            isRightPanelExpand: true
        };

        switch (view) {
            case "rightPanel":
                resetComponentDisplayStates({ showWorkkardMainInfo: true, showWorkkardOwners: true, showAssociatedWorkkards: true });
                setAddAnimationClassOnThirdLayout(true);
                panelVisibilityPayload.isLeftVisible = !panelVisibility.isVisibleExternalApp;
                panelVisibilityPayload.isFullViewActive = true;
                break;
            case "wkDetail":
                resetComponentDisplayStates({ showWorkkardMainInfo: !showWorkkardMainInfo });
                break;
            case "associatedWk":
                resetComponentDisplayStates({ showAssociatedWorkkards: !showAssociatedWorkkards });
                break;
            case "changeOwner":
                resetComponentDisplayStates({ showWorkkardOwners: !showWorkkardOwners });
                break;
        }

        dispatch(setPanelVisibility(panelVisibilityPayload));
    };

    const getWorkkardFiles = (workkardId) => (<WorkkardFiles workkardId={workkardId} history={props.history} />);

    const switcherClassName = (!panelVisibility.isRightPanelExpand || !showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? "switcher_active" : '';

    return (
        <div className={classNames(`thirdLayout animated ${isDesktop() ? 'faster' : 'superFaster'} forMobileUp ${addAnimationClassOnThirdLayout ? 'animated faster fadeInLeft' : ''} ${isMobileState && props.showChangeOwnerBlock ? 'changeOwnerOverlay' : ''}` + switcherClassName)} ref={thirdLayoutRef}>
            {
                panelVisibility.isRightPanelExpand && (showWorkkardMainInfo || showWorkkardOwners || showAssociatedWorkkards) ?
                    (
                        <React.Fragment>
                            {
                                showWorkkardMainInfo &&
                                <header className="rowFlex rowSpaceBetween headingWkDetail" ref={headingWkDetailRef}>
                                    <h2 onClick={showWorkkardDetailPopUp}>
                                        {RightPanelConstant.WorkkardDetailText}
                                    </h2>
                                    {!props.showPopUp && !panelVisibility.isNoteCreationVisible &&
                                        (
                                            (showWorkkardMainInfo || showWorkkardOwners || showAssociatedWorkkards) ? <span onClick={onCloseWorkkardInfo}>
                                                <div className="alignMiddle">
                                                    <span className="closeIcon wkDetailFullView">
                                                        <span className="iconRipple"><Icon name="close" className="icon close" /></span>
                                                        <ul className="layoutChange animated fast fadeInRightSmall">
                                                            <li className="active"><span className="quickTooltip-left" data-quicktooltip="Full view" onClick={expandMiddlePanel}><Icon name="SingleLayout" className="icon singleLayout" /></span></li>
                                                        </ul>
                                                    </span>
                                                </div>
                                            </span> : null
                                        )
                                    }
                                    {props.showPopUp && <div style={{ zIndex: 1 }} onClick={props.closeMblPopUp}><Icon name="close" className="icon" /></div>}
                                    { // for closing workkard details panel move this block where you want !!for Design Team!!
                                        (
                                            !panelVisibility.isLeftVisible && panelVisibility.isNoteCreationVisible && !props.showPopUp
                                        )
                                            ?
                                            (
                                                <span onClick={onCloseWorkkardDetail}>
                                                    <Icon name="close" className="icon" />
                                                </span>
                                            )
                                            :
                                            null
                                    }
                                </header>
                            }
                            <div className={`wkDetailScroll scrollArea  ${!(!showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? '' : ''}`}>
                                <div className={`animated faster ${(showWorkkardMainInfo && !showWorkkardOwners && !showAssociatedWorkkards) ? 'fadeInUp' : ''}`}>{workkardMainInfo(workkard)}</div>
                                {workkard && workkard.Id && isModuleEnabled("workkards.workkard_files_tab") && getWorkkardFiles(workkard.Id)}
                                <div ref={changeOwnerDivRef} className={isWorkkardInfoCollapsed ? "onCollapsedOnly colFlex" : null}>
                                    {isModuleEnabled("workkards.associated_workkard.filters") && workkard.TemplateId !== 0 && associatedWorkkard(workkard)}
                                    {isModuleEnabled("workkards.workkard_owner_assignee_details") && changeOwnerComponent(workkard)}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        null
                    )
            }
            <div className={`switcher animated delay-5ms superFaster ${(!panelVisibility.isRightPanelExpand || !showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? 'fadeInLeft' : 'fadeInRight'}`}>
                {
                    (!panelVisibility.isRightPanelExpand || !showWorkkardMainInfo || !showWorkkardOwners || !showAssociatedWorkkards) ? (
                        <ul>
                            <li onClick={() => switchViewClick("rightPanel")}><a href="javascript:void(0)" className="" title="Workkard Detail"><span className="iconRipple"><Icon name="chev" className="icon shift__top__1 arrow" /></span></a></li>
                            <li onClick={() => switchViewClick("wkDetail")} className={showWorkkardMainInfo ? "active iconHover" : "iconHover"}><a href="javascript:void(0)" className="" title="Workkard Detail"><Icon name="WorkkardDetail" className="icon shift__top__1" /></a></li>
                            <li onClick={() => switchViewClick("associatedWk")} className={showAssociatedWorkkards ? "active iconHover" : "iconHover"}><a href="javascript:void(0)" className="" title="Associated Workkards"><Icon name="associatedWorkkards" className="icon shift__top__1" /></a></li>
                            <li onClick={() => switchViewClick("changeOwner")} className={showWorkkardOwners ? "active iconHover" : "iconHover"}><a href="javascript:void(0)" className="" title="Change Owner/Assignee"><Icon name="changeOwners" className="icon shift__top__1" /></a></li>
                        </ul>
                    ) : null
                }
            </div>
        </div>
    );
};


const OpenButton = () => (
    <div className="expandCollaps collapseIcon">
        <Icon name="collapse" className="icon" />
    </div>
);


const CloseButton = () => (
    <div className="expandCollaps collapseIcon">
        <Icon name="collapse" className="icon up" />
    </div>
);

export default RightPanelContainer;

